'use client';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import CheckoutStepBuylistLocationInput from './CheckoutStepBuylistLocationInput';

let allActionCreators = Object.assign({});

export class CheckoutStepBuylistLocation extends Component {

	constructor(props) {
		super(props);

		this.state = {
			localStore: null,
		};
	}

	componentDidMount() {
		this.setState({ localStore: this.props.user?.store ?? null });
	}

	getStepComponent() {

		const { checkoutPrereqMet } = require('../../../../../utils/checkout');

		// If pre-requisites not met, do not display
		if(checkoutPrereqMet(this.props.config, this.props.checkout.stepData) === false) {
			return null;
		}

		// const { CheckoutStepBuylistLocationInput } = require('./CheckoutStepBuylistLocationInput').default;

		return <CheckoutStepBuylistLocationInput 
					config={this.props.config}
					setStepData={this.props.setStepData} />;
	}

	render() {

		if(!this.state.localStore?.multiLocation) {
			return null;
		}

		return <div className={'CheckoutStepBuylistLocation'}>{this.getStepComponent()}</div>;
	}
}

function mapStateToProps(state) {
	return {
		checkout: state.checkout,
		user: state.user,
	};
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(CheckoutStepBuylistLocation));